<div class="layout-sidebar" [attr.aria-label]="'ACCESSIBILITY.SIDEBAR_NAV' | translate" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-header" aria-label = "sidebar header">
        <a [routerLink]="['/']" class="app-logo cursor-pointer">
            <img [src]="logoSrc" [attr.alt]="'APP.LOGO_ALT' | translate" class="p-p-3 p-mb-3" style="width: 130px; height: auto;"/>
        </a>
        <button class="layout-sidebar-anchor p-link" type="button" (click)="anchor()" 
            [attr.aria-label]="(layoutService.state.anchored ? 'TOOLTIP.SIDEBAR.UNPIN' : 'TOOLTIP.SIDEBAR.PIN') | translate"
            [attr.aria-pressed]="layoutService.state.anchored"
        >
            <i aria-hidden="true"></i>
        </button>
    </div>

    <div #menuContainer class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>
